/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { Account } from '@carbon/react/icons';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { FormattedMessageWithLink } from '../../../helpers/linkHelpers';
import { ChannelContentProps } from '../../../util/types';
import { TabContent } from '../../common/tabbed-header/TabContent';
import { links } from '../links';
import {
  AppReviewStepMessages,
  ConnectAssistantStepMessages
} from '../new/messages';
import { AdvancedOptions as messages } from './messages';

export const AdvancedOptions = (_props: ChannelContentProps) => {
  return (
    <TabContent
      ImageComponent={() => <Account size={32} />}
      title={<FormattedMessage {...messages.title} />}>
      <div className="TabContent__body-content">
        <div className="TabContent__subtitle">
          <FormattedMessage {...ConnectAssistantStepMessages.message} />
        </div>
        <div className="TabContent__spacer8" />
        <div className="TabContent__subtitle TabContent__link-larger-text">
          <FormattedMessageWithLink
            url={links.FACEBOOK_FOR_DEVELOPERS_SUBMITTING_APP_LINK}
            {...AppReviewStepMessages.description}
          />
        </div>
      </div>
    </TabContent>
  );
};
